/* Call112: Warenkorb-Drawer im More-Nutrition-Stil (mn-cart.js)
   Ergaenzt den Impulse Cart Drawer um Rabattcode, Stufenbalken, Cross-Sell,
   Versandprioritaet und Entfernen ohne Seiten-Reload. */
(function () {
  'use strict';
  if (window.__mnCartLoaded) return;
  window.__mnCartLoaded = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var S = {
    codeEmpty: 'Bitte gib einen Code ein.',
    codeInvalid: 'Dieser Code ist ungültig oder für deinen Warenkorb nicht anwendbar.',
    codeApplied: 'Code wurde angewendet.',
    codeExists: 'Dieser Code ist bereits aktiv.',
    error: 'Das hat nicht geklappt. Bitte versuche es erneut.'
  };

  function loadStrings() {
    var el = document.getElementById('MnCartStrings');
    if (!el) return;
    try {
      var j = JSON.parse(el.textContent);
      for (var k in j) { if (j[k]) S[k] = j[k]; }
    } catch (e) {}
  }

  var loadingTimer;
  function setLoading(on) {
    var d = document.getElementById('CartDrawer');
    if (!d) return;
    d.classList.toggle('mn-is-loading', !!on);
    clearTimeout(loadingTimer);
    if (on) loadingTimer = setTimeout(function () { setLoading(false); }, 8000);
  }

  function request(url, data) {
    var opts = { credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (data !== undefined) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(data);
    }
    return fetch(root + url, opts).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || (j && j.status && j.status >= 400)) {
          var e = new Error((j && (j.description || j.message)) || 'Error');
          e.data = j;
          throw e;
        }
        return j;
      });
    });
  }

  function getCart() { return request('cart.js?t=' + Date.now()); }

  function rebuild(cart) {
    document.dispatchEvent(new CustomEvent('cart:build'));
    if (cart && cart.items) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }
    return cart;
  }

  function refresh() { return getCart().then(rebuild); }

  function showAlert(text) {
    var el = document.querySelector('#CartDrawer [data-mn-alert]');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
    clearTimeout(showAlert._t);
    if (text) showAlert._t = setTimeout(function () { el.hidden = true; }, 6000);
  }

  function fail(err) {
    setLoading(false);
    var msg = (err && err.data && (err.data.description || err.data.message)) || S.error;
    showAlert(msg);
    if (window.console) console.warn('[mn-cart]', err);
  }

  function codeMsg(text, type) {
    var el = document.querySelector('#CartDrawer [data-mn-code-msg]');
    if (!el) return;
    el.textContent = text || '';
    el.className = 'mn-code__msg' + (type ? ' is-' + type : '');
    clearTimeout(codeMsg._t);
    if (text && type === 'success') codeMsg._t = setTimeout(function () { el.textContent = ''; }, 4000);
  }

  /* Artikel entfernen (Papierkorb oder Minus bei Menge 1) */
  function removeLine(key) {
    setLoading(true);
    return request('cart/change.js', { id: key, quantity: 0 }).then(rebuild).catch(fail);
  }

  /* Rabattcodes */
  function activeCodes(cart) {
    return (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
  }

  function applyCode() {
    var input = document.querySelector('#CartDrawer [data-mn-code-input]');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) { codeMsg(S.codeEmpty, 'error'); input.focus(); return; }
    var lower = code.toLowerCase();
    codeMsg('', '');
    setLoading(true);
    getCart().then(function (cart) {
      var existing = activeCodes(cart);
      if (existing.some(function (c) { return c.toLowerCase() === lower; })) {
        setLoading(false);
        codeMsg(S.codeExists, 'error');
        return;
      }
      return request('cart/update.js', { discount: existing.concat([code]).join(',') }).then(function (updated) {
        var hit = (updated.discount_codes || []).filter(function (d) { return (d.code || '').toLowerCase() === lower; })[0];
        if (hit && hit.applicable) {
          input.value = '';
          codeMsg(S.codeApplied, 'success');
          rebuild(updated);
        } else {
          return request('cart/update.js', { discount: existing.join(',') }).then(function (reverted) {
            codeMsg(S.codeInvalid, 'error');
            rebuild(reverted);
          });
        }
      });
    }).catch(function (err) {
      setLoading(false);
      codeMsg(S.codeInvalid, 'error');
      if (window.console) console.warn('[mn-cart]', err);
    });
  }

  function removeCode(code) {
    var lower = (code || '').toLowerCase();
    setLoading(true);
    getCart().then(function (cart) {
      var rest = activeCodes(cart).filter(function (c) { return c.toLowerCase() !== lower; });
      return request('cart/update.js', { discount: rest.join(',') }).then(rebuild);
    }).catch(fail);
  }

  /* Versandprioritaet */
  function togglePriority(input) {
    setLoading(true);
    var p = input.checked
      ? request('cart/add.js', { items: [{ id: parseInt(input.getAttribute('data-variant-id'), 10), quantity: 1 }] })
      : request('cart/change.js', { id: input.getAttribute('data-line-key'), quantity: 0 });
    p.then(refresh).catch(function (e) {
      input.checked = !input.checked;
      fail(e);
    });
  }

  /* Cross-Sell */
  function addUpsell(btn) {
    var card = btn.closest('[data-mn-upsell-card]');
    var sel = card && card.querySelector('[data-mn-upsell-select]');
    var id = parseInt((sel && sel.value) || btn.getAttribute('data-variant-id'), 10);
    if (!id) return;
    btn.classList.add('is-loading');
    setLoading(true);
    request('cart/add.js', { items: [{ id: id, quantity: 1 }] }).then(refresh).catch(function (e) {
      btn.classList.remove('is-loading');
      fail(e);
    });
  }

  function onUpsellSelect(sel) {
    var opt = sel.options[sel.selectedIndex];
    var card = sel.closest('[data-mn-upsell-card]');
    if (!opt || !card) return;
    var price = card.querySelector('[data-mn-price]');
    var cmp = card.querySelector('[data-mn-compare]');
    if (price) price.textContent = opt.getAttribute('data-price') || '';
    if (cmp) cmp.textContent = opt.getAttribute('data-compare') || '';
  }

  function scrollUpsell(btn) {
    var wrap = btn.closest('.mn-upsell');
    var track = wrap && wrap.querySelector('[data-mn-upsell-track]');
    if (!track) return;
    var dir = parseInt(btn.getAttribute('data-mn-scroll'), 10) || 1;
    track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.8, 150), behavior: 'smooth' });
  }

  /* Dynamische Bereiche nach jedem Neuaufbau des Warenkorbs austauschen */
  var cleaning = false;
  function applyExtras(text) {
    setLoading(false);
    if (!text) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = text;
    var src = tmp.querySelector('.mn-extras');
    if (!src) return;
    var parts = src.querySelectorAll('[data-mn-src]');
    for (var i = 0; i < parts.length; i++) {
      var name = parts[i].getAttribute('data-mn-src');
      var targets = document.querySelectorAll('[data-mn-slot="' + name + '"]');
      for (var j = 0; j < targets.length; j++) targets[j].innerHTML = parts[i].innerHTML;
    }
    var only = src.querySelector('[data-mn-only-priority]');
    if (only && !cleaning) {
      cleaning = true;
      removeLine(only.getAttribute('data-mn-only-priority')).then(function () { cleaning = false; });
    }
  }

  function patch() {
    var th = window.theme;
    if (!th || !th.CartForm || !th.CartForm.prototype) return false;
    var proto = th.CartForm.prototype;
    if (proto.__mnPatched) return true;
    var orig = proto.cartMarkup;
    proto.cartMarkup = function (text) {
      var res = orig.apply(this, arguments);
      try { applyExtras(text); } catch (e) { setLoading(false); }
      return res;
    };
    proto.__mnPatched = true;
    return true;
  }

  /* Events */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var el;
    if ((el = t.closest('[data-mn-remove]'))) { e.preventDefault(); removeLine(el.getAttribute('data-mn-remove')); return; }
    if ((el = t.closest('[data-mn-code-apply]'))) { e.preventDefault(); applyCode(); return; }
    if ((el = t.closest('[data-mn-remove-code]'))) { e.preventDefault(); removeCode(el.getAttribute('data-mn-remove-code')); return; }
    if ((el = t.closest('[data-mn-upsell-add]'))) { e.preventDefault(); addUpsell(el); return; }
    if ((el = t.closest('[data-mn-scroll]'))) { e.preventDefault(); scrollUpsell(el); }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-mn-priority]')) togglePriority(t);
    else if (t.matches('[data-mn-upsell-select]')) onUpsellSelect(t);
  });

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (e.key === 'Enter' && t && t.matches && t.matches('[data-mn-code-input]')) {
      e.preventDefault();
      e.stopPropagation();
      applyCode();
    }
  }, true);

  function onQty(evt) {
    var d = evt.detail || [];
    if (!d[0]) return;
    if (d[1] === 0) removeLine(d[0]);
    else setLoading(true);
  }
  ['cart:quantity.cart-cart-drawer', 'cart:quantity.cart-page', 'cart:quantity.cart-cart-page'].forEach(function (n) {
    document.addEventListener(n, onQty);
  });

  if (!patch()) document.addEventListener('DOMContentLoaded', patch);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadStrings);
  else loadStrings();

  window.mnCart = { refresh: refresh, applyExtras: applyExtras };
})();
